import { METHOD_API, createConnector, prefixApi } from "./Connector";
import { User } from "services/models";
interface sortData {
  PK: String;
  SK: String;
  sort: Number;
  user: User;
}

export const getListCategory = () => {
  return createConnector(METHOD_API.GET, `${prefixApi}/category`, null);
};

export const updateCategorySort = (dataBody: sortData[]) => {
  return createConnector(
    METHOD_API.UPLOAD_FORM_POST,
    `${prefixApi}/category/sort`,
    dataBody,
  );
};

export const deleteCategory = (category_is: string) => {
  return createConnector(
    METHOD_API.DELETE,
    `${prefixApi}/category/${encodeURIComponent(category_is)}`,
    null,
  );
};
